import styled from 'styled-components'
import { colors } from '../../../config/theme'

export const StateStyled = styled.span`
  color: ${(props) => (props.active ? colors.primary.main : colors.states.error)};
`
